module.exports = __webpack_public_path__ + "static/img/Logo2.49ae7f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Logo2.png
// module id = nJEX
// module chunks = 1